/* components/AccordionContainer.ts

Standard Accordion Component
Content slides up or down depending on whether it has class 'accordion--open'

Use within liquid as:
{! component 'AccordionContainer', header: 'This is an Example', content: accordionContent, class:'example__class' !}

*/
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { AccordionHeader } from '@/components/Accordion/AccordionHeader';
import { AccordionBody } from '@/components/Accordion/AccordionBody';

@Component
export class AccordionContainer extends ThemeComponent {
    @Ref accordionHeader!: AccordionHeader;
    @Ref accordionBody!: AccordionBody;
    init() {
        this.$subscribe(this.accordionHeader.onOpenChange, (open: string) => {
            this.toggleOpen(open);
        });
    }
    private toggleOpen(open: string) {
        if (open == 'true') {
            this.classList.add('accordion--open');
            const height = this.accordionBody.scrollHeight + 25;
            this.accordionBody.style.height = height + 'px';
        } else {
            this.classList.remove('accordion--open');
            this.accordionBody.style.height = '0px';
        }
    }
}
